import { createTypes, createActions } from '@wix/restaurants-redux/dist/actions/ActionCreatorHelper';
import PropTypes from 'proptypes';

const seatingActions = [
    {
        type: 'INIT_FORM',
        propTypes: {
            errors: PropTypes.shape({
                date: PropTypes.any,
                time: PropTypes.any,
                party: PropTypes.any,
                firstName: PropTypes.any,
                lastName: PropTypes.any,
                email: PropTypes.any,
                phone: PropTypes.any,
                requests: PropTypes.any
            }),
            reservation: PropTypes.shape({
                date: PropTypes.string,
                time: PropTypes.any,
                party: PropTypes.any,
                firstName: PropTypes.string,
                lastName: PropTypes.string,
                phone: PropTypes.string,
                email: PropTypes.string,
                requests: PropTypes.any
            }),
            options: PropTypes.shape({
                party: PropTypes.array,
                time: PropTypes.array,
                date: PropTypes.object
            })
        }
    },
    {
        type: 'SET_FORM_OPTIONS',
        propTypes: {
            partyOptions: PropTypes.arrayOf(PropTypes.shape({
                name: PropTypes.string.isRequired,
                value: PropTypes.number.isRequired
            })),
            timeOptions: PropTypes.arrayOf(PropTypes.shape({
                name: PropTypes.string.isRequired,
                value: PropTypes.object.isRequired
            })),
            excludeDates: PropTypes.object
        }
    },
    {
        type: 'VALIDATE_RESERVATION',
        propTypes: {}
    },
    {
        type: 'SET_POLICY_ERROR',
        propTypes: {
            policyError:PropTypes.bool
        }
    },
    {
        type: 'SET_SHOW_POLICY_ERROR',
        propTypes: {
            showPolicyError:PropTypes.bool
        }
    },
    {
        type: 'VALIDATE_FULL_RESERVATION',
        propTypes: {}
    },
    {
        type: 'VALIDATE_DETAILS',
        propTypes: {}
    },
    {
        type: 'RESERVATION_VALIDATION_ERROR',
        propTypes: {
            errors: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string.isRequired,
                reason: PropTypes.string
            })).isRequired
        }
    },
    {
        type: 'UPDATE_RESERVATION_VALIDATION_ERROR',
        propTypes: {
            errors: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string.isRequired,
                error: PropTypes.boole
            })).isRequired
        }
    },
    {
        type: 'RESERVATION_VALIDATION_OK',
        propTypes: {}
    },
    {
        type: 'FULL_RESERVATION_VALIDATION_OK',
        propTypes: {}
    },
    {
        type: 'FULL_RESERVATION_VALIDATION_ERROR',
        propTypes: {
            errors: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string.isRequired,
                reason: PropTypes.string
            })).isRequired
        }
    },
    {
        type: 'UPDATE_FIELD',
        propTypes: {
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.object,
                PropTypes.any
            ]),
            type: PropTypes.string.isRequired
        }
    },
    {
        type: 'UPDATE_FIELD_END',
        propTypes: {
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.object,
                PropTypes.any
            ]),
            type: PropTypes.string.isRequired
        }
    },
    {
        type: 'SET_FIELDS',
        propTypes: {
            date: PropTypes.string,
            time: PropTypes.object,
            party: PropTypes.number,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            phone: PropTypes.string,
            email: PropTypes.string,
            requests: PropTypes.string,
            customFields: PropTypes.array
        }
    },
    {
        type: 'RESET_FORM',
        propTypes: {}
    },
    {
        type: 'CHANGE_LOCATION',
        propTypes: {
            locationId: PropTypes.string
        }
    }
];

const ACTION_PREFIX = 'SEATING_FORM_';
export const types   = createTypes(seatingActions, ACTION_PREFIX);
export const actions = createActions(seatingActions, ACTION_PREFIX);
